import {
  Badge,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui';

/**
 * Client badge for MCP servers provisioned via CIMD (OAuth Client ID Metadata
 * Documents): the authorization server accepts our hosted client-identity URL,
 * so no OAuth app exists — by design, not by omission. Rendered wherever the
 * client column/field would otherwise say "Not configured".
 */
export function CimdClientBadge() {
  return (
    <Tooltip>
      <TooltipTrigger>
        <Badge variant="info">CIMD</Badge>
      </TooltipTrigger>
      <TooltipContent>
        No app registration needed — this server accepts our hosted client
        identity (Client ID Metadata Document).
      </TooltipContent>
    </Tooltip>
  );
}
